import { useTranslation } from "@crehana/i18n";
import { PrimaryButton } from "@crehana/ui";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ThanksView = function ThanksView(_ref) {
  var closeDialog = _ref.closeDialog;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col items-center justify-center h-screen px-24 py-48 bg-base-dark sm:justify-start sm:h-auto",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "mb-24 sm:mb-32",
      children: [/*#__PURE__*/_jsx("p", {
        className: "mb-16 text-center text-white font-h2",
        children: t('READY', {
          defaultValue: '¡Listo!'
        })
      }), /*#__PURE__*/_jsx("p", {
        className: "text-center text-white font-body3",
        children: t('WE_WILL_BE_WITH_YOU', {
          defaultValue: 'Estaremos conversando contigo muy pronto :)'
        })
      })]
    }), /*#__PURE__*/_jsx(PrimaryButton, {
      darkMode: true,
      size: "l",
      label: t('END', {
        defaultValue: 'Finalizar'
      }),
      onClick: closeDialog
    })]
  });
};
export default ThanksView;